import MenuIcon from '@mui/icons-material/Menu';
import MoreIcon from '@mui/icons-material/MoreVert';
import {AppBar, Hidden} from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import clsx from 'clsx';
import AdminHeaderButton from 'modules/admin/components/AdminHeaderButton';
import {UserType} from 'modules/auth/models/AuthUser';
import MyFieldsHeaderButton from 'modules/fields/components/MyFieldsHeaderButton';
import NitrogenHeaderButton from 'modules/nitrogen/components/NitrogenHeaderButton';
import VegetationHeaderButton from 'modules/vegetation/components/VegetationHeaderButton';
import VisioCropHeaderButton from 'modules/visio_crop/components/VisioCropHeaderButton';
import IrrigationHeaderButton from 'modules/waterBalance/components/IrrigationHeaderButton';
import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {onToggleAppDrawer, setHeaderHeight} from 'shared/actions/Common';
import {AppState} from 'shared/store';
import UserHeaderButton from '../../../modules/auth/components/UserHeaderButton';
import LanguageSwitcher from '../LanguageSwitcher';
import useStyles from './AppHeader.style';
import HeaderLogo from './HeaderLogo';

interface AppHeaderProps {}

const AppHeader: React.FC<AppHeaderProps> = () => {
  const appBarRef = useRef<any>(null);
  const classes = useStyles();
  const dispatch = useDispatch();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState<null | HTMLElement>(null);

  function handleMobileMenuOpen(event: React.MouseEvent<HTMLElement>) {
    setMobileMoreAnchorEl(event.currentTarget);
  }

  const {customer} = useSelector<AppState, AppState['auth']>((state) => state.auth);
  const mobileMenuId = 'primary-search-account-menu-mobile';

  useEffect(() => {
    if (appBarRef.current) {
      dispatch(setHeaderHeight(appBarRef.current.offsetHeight));
    }
  }, []);

  return (
    <>
      <AppBar ref={appBarRef} color='primary' className={clsx(classes.appBar, 'app-bar')}>
        <Toolbar className={classes.appToolbar}>
          <Hidden lgUp>
            <IconButton
              edge='start'
              className={classes.menuButton}
              color='inherit'
              aria-label='open drawer'
              onClick={() => dispatch(onToggleAppDrawer())}>
              <MenuIcon className={classes.menuIcon} />
            </IconButton>
          </Hidden>
          <Box className={classes.sectionDesktop}>
            <Box display={'flex'} gap={6} alignItems={'center'}>
              <HeaderLogo />
              <MyFieldsHeaderButton />
            </Box>
            <Box>
              <IrrigationHeaderButton />
              <VegetationHeaderButton />
              <NitrogenHeaderButton />
              {customer && customer.visio_crop_access && <VisioCropHeaderButton />}
              {/* <CarbonHeaderButton /> */}
              {/* <WeatherHeaderButton /> */}
            </Box>
            <Box display={'flex'}>
              <UserHeaderButton />
            </Box>
          </Box>
          {customer &&
            customer.user_type &&
            (customer.user_type === UserType.CUSTOMER_MANAGER || customer.user_type === UserType.OPERATOR) && (
              <Box borderLeft={1} borderRight={1}>
                <AdminHeaderButton />
              </Box>
            )}
          <Box className={classes.sectionMobile}>
            <IconButton
              aria-label='show more'
              aria-controls={mobileMenuId}
              aria-haspopup='true'
              onClick={handleMobileMenuOpen}
              color='inherit'>
              <MoreIcon />
            </IconButton>
          </Box>
          <LanguageSwitcher localeOnly />
        </Toolbar>
      </AppBar>
    </>
  );
};
export default AppHeader;
